import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../images/logo-da.jpg';
import './Navigation.css';

const Navigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout } = useAuth();
    const [menuOpen, setMenuOpen] = useState(false);

    // Close the mobile menu whenever the route changes.
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    const isActive = (path) => location.pathname === path;
    const isBlogActive = location.pathname === '/blog' || location.pathname.startsWith('/blog/');

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <header className={`navigation ${menuOpen ? 'menu-open' : ''}`}>
            <div className="navigation-left">
                <img
                    src={logo}
                    alt="DonAllison.ca Logo"
                    height="40"
                    className="logo"
                    onClick={() => navigate('/')}
                />
                <button
                    className="nav-toggle"
                    aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                    aria-expanded={menuOpen}
                    aria-controls="navigation-menu"
                    onClick={() => setMenuOpen((open) => !open)}
                >
                    <span className="nav-toggle-bar" />
                    <span className="nav-toggle-bar" />
                    <span className="nav-toggle-bar" />
                </button>
            </div>
            <nav id="navigation-menu" className="navigation-right">
                <button
                    className={`nav-button ${isActive('/') ? 'active' : ''}`}
                    onClick={() => navigate('/')}
                >
                    Home
                </button>
                <button
                    className={`nav-button ${isActive('/apps') ? 'active' : ''}`}
                    onClick={() => navigate('/apps')}
                >
                    Apps
                </button>
                <button
                    className={`nav-button ${isActive('/links') ? 'active' : ''}`}
                    onClick={() => navigate('/links')}
                >
                    Links
                </button>
                <button
                    className={`nav-button ${isBlogActive ? 'active' : ''}`}
                    onClick={() => navigate('/blog')}
                >
                    Blog
                </button>
                <button
                    className={`nav-button ${isActive('/news') ? 'active' : ''}`}
                    onClick={() => navigate('/news')}
                >
                    News
                </button>
                {user ? (
                    <>
                        <button
                            className={`nav-button ${isActive('/stocks') ? 'active' : ''}`}
                            onClick={() => navigate('/stocks')}
                        >
                            Stocks
                        </button>
                        <button
                            className={`nav-button ${isActive('/markets') ? 'active' : ''}`}
                            onClick={() => navigate('/markets')}
                        >
                            Markets
                        </button>
                        {user.is_admin && (
                            <button
                                className={`nav-button ${isActive('/admin') ? 'active' : ''}`}
                                onClick={() => navigate('/admin')}
                            >
                                Admin
                            </button>
                        )}
                        <button className="nav-button" onClick={handleLogout}>
                            Logout
                        </button>
                    </>
                ) : (
                    <button
                        className={`nav-button ${isActive('/login') ? 'active' : ''}`}
                        onClick={() => navigate('/login')}
                    >
                        Login
                    </button>
                )}
            </nav>
        </header>
    );
};

export default Navigation;
